export function Logo({ className }: { className?: string }) {
  // Marca completa: ícone de calculadora (verde da marca) + wordmark.
  // SVG inline pra herdar as variáveis de cor do design system.
  return (
    <span
      className={`inline-flex items-center gap-2 select-none ${className ?? ""}`}
      aria-label="Calcula MEI"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <rect x="1.5" y="1.5" width="29" height="29" rx="6" fill="rgb(var(--green-soft))" />
        <rect
          x="1.5"
          y="1.5"
          width="29"
          height="29"
          rx="6"
          stroke="rgb(var(--green-deep))"
          strokeWidth="2.4"
        />
        <rect x="7" y="7.5" width="18" height="5.5" rx="1.6" fill="rgb(var(--green-deep))" />
        <rect x="7" y="16.5" width="5" height="4" rx="1.2" fill="rgb(var(--green-deep))" />
        <rect x="13.5" y="16.5" width="5" height="4" rx="1.2" fill="rgb(var(--green-deep))" />
        <rect x="20" y="16.5" width="5" height="9.5" rx="1.2" fill="rgb(var(--green-deep))" />
        <rect x="7" y="22" width="5" height="4" rx="1.2" fill="rgb(var(--green-deep))" />
        <rect x="13.5" y="22" width="5" height="4" rx="1.2" fill="rgb(var(--green-deep))" />
      </svg>
      <span className="inline-flex items-baseline gap-[2px]">
        <span className="font-display font-extrabold text-[24px] leading-none tracking-tight text-foreground">
          Calcula
        </span>
        <span
          className="font-display font-extrabold text-[24px] leading-none tracking-tight"
          style={{ color: "rgb(var(--green-deep))" }}
        >
          MEI
        </span>
      </span>
    </span>
  )
}
